import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    padding: 8px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    position: relative;\n\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n              width: 100%;\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    min-width: 100%;\n    max-height: ", "px;\n    overflow: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState, useCallback, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { TextField } from '../TextField';
import { Balloon, useBalloon } from '../Balloon';
import { Typography } from '../Typography';
import { List, ListItem } from '../List';
import { Loader } from '../Loader';
import { noop } from '../helpers';
var DEFAULT_STRINGS = {
  error: ''
};
var Keys = {
  TAB: 'Tab',
  BACKSPACE: 'Backspace',
  ENTER: 'Enter',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown'
};
var SuggestContent = styled.div(_templateObject());
var MenuList = styled(List)(_templateObject2(), function (_ref) {
  var suggestsMaxCount = _ref.suggestsMaxCount;
  return suggestsMaxCount * 35;
});

function fullWidth(_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth ? css(_templateObject3()) : null;
}

var StyledSuggest = styled.div(_templateObject4(), fullWidth);
var SuggestBalloon = styled(Balloon)(_templateObject5());
var Note = styled(Typography)(_templateObject6());

function defaultRenderSuggestItem(_ref3) {
  var text = _ref3.text;
  return text;
}

export function Suggest(_a) {
  var initialValue = _a.initialValue,
      inputValue = _a.value,
      _a$suggests = _a.suggests,
      suggests = _a$suggests === void 0 ? [] : _a$suggests,
      _a$suggestsMaxCount = _a.suggestsMaxCount,
      suggestsMaxCount = _a$suggestsMaxCount === void 0 ? 5 : _a$suggestsMaxCount,
      _a$error = _a.error,
      error = _a$error === void 0 ? false : _a$error,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$readOnly = _a.readOnly,
      readOnly = _a$readOnly === void 0 ? false : _a$readOnly,
      _a$fullWidth = _a.fullWidth,
      fullWidth = _a$fullWidth === void 0 ? false : _a$fullWidth,
      _a$loading = _a.loading,
      loading = _a$loading === void 0 ? false : _a$loading,
      _a$strings = _a.strings,
      strings = _a$strings === void 0 ? DEFAULT_STRINGS : _a$strings,
      _a$renderSuggestItem = _a.renderSuggestItem,
      renderSuggestItem = _a$renderSuggestItem === void 0 ? defaultRenderSuggestItem : _a$renderSuggestItem,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? noop : _a$onChange,
      _a$onSelect = _a.onSelect,
      onSelect = _a$onSelect === void 0 ? noop : _a$onSelect,
      _a$onFocus = _a.onFocus,
      onFocus = _a$onFocus === void 0 ? noop : _a$onFocus,
      _a$onBlur = _a.onBlur,
      onBlur = _a$onBlur === void 0 ? noop : _a$onBlur,
      _a$onSubmit = _a.onSubmit,
      onSubmit = _a$onSubmit === void 0 ? noop : _a$onSubmit,
      props = __rest(_a, ["initialValue", "value", "suggests", "suggestsMaxCount", "error", "disabled", "readOnly", "fullWidth", "loading", "strings", "renderSuggestItem", "onChange", "onSelect", "onFocus", "onBlur", "onSubmit"]);

  var _ref4 = initialValue != null ? useState(initialValue) : [inputValue, function (value) {
    return onChange({
      value: value
    });
  }],
      _ref5 = _slicedToArray(_ref4, 2),
      value = _ref5[0],
      setValue = _ref5[1];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      hoveredSuggestIndex = _useState2[0],
      setHoveredSuggestIndex = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocus = _useState4[0],
      setFocus = _useState4[1];

  var _useBalloon = useBalloon(),
      isBalloonOpened = _useBalloon.isBalloonOpened,
      toggleBalloon = _useBalloon.toggleBalloon;

  var inputRef = useRef(null);
  var suggestListRef = useRef(null);
  useEffect(function () {
    setHoveredSuggestIndex(null);
  }, [suggests, isBalloonOpened]);
  var handleChangeTextField = useCallback(function (_ref6) {
    var value = _ref6.target.value;
    setValue(value);

    if (initialValue != null) {
      onChange({
        value: value
      });
    }
  }, [setValue, initialValue, onChange]);
  var handleToggleSuggests = useCallback(function () {
    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (disabled || readOnly) {
      return;
    }

    toggleBalloon(toggle);
  }, [disabled, readOnly, toggleBalloon]);
  var handleFocus = useCallback(function () {
    setFocus(true);
    onFocus();
  }, [onFocus, setFocus]);
  useEffect(function () {
    if (isFocus) {
      handleToggleSuggests(error || Boolean(suggests.length));
    }
  }, [suggests, isFocus, error]);
  var handleBlur = useCallback(function () {
    var _a;

    handleToggleSuggests(false);
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    onBlur();
  }, [inputRef, onBlur, handleToggleSuggests]);
  var handleTextFieldBlur = useCallback(function () {
    setFocus(false);
  }, [setFocus]);
  var handleSelectSuggest = useCallback(function (suggest) {
    var text = suggest.text;

    if (initialValue != null) {
      handleChangeTextField({
        target: {
          value: text
        }
      });
    }

    onSelect({
      value: suggest
    });
    handleBlur();
  }, [handleChangeTextField, onSelect, handleBlur]);
  var scrollToSuggest = useCallback(function (activeSuggestIndex) {
    var suggestsNode = suggestListRef.current;

    if (!suggestsNode) {
      return;
    }

    var activeNode = suggestsNode.children[activeSuggestIndex] || suggestsNode.children[0];

    if (!activeNode) {
      return;
    }

    var bottomOffset = suggestsNode.scrollTop + suggestsNode.offsetHeight - activeNode.offsetTop - activeNode.offsetHeight;

    if (bottomOffset < 0) {
      activeNode.scrollIntoView(false);
      return;
    }

    var topOffset = activeNode.offsetTop - suggestsNode.scrollTop;

    if (topOffset < 0) {
      activeNode.scrollIntoView(true);
    }
  }, [suggestListRef]);
  var handleKeydownInput = useCallback(function (event) {
    var key = event.key;

    if (Keys.TAB === key) {
      handleBlur();
      return;
    }

    if (![Keys.ENTER, Keys.ARROW_UP, Keys.ARROW_DOWN].includes(key)) {
      return;
    }

    event.preventDefault();

    switch (key) {
      case Keys.ARROW_UP:
        {
          var length = suggests.length;

          if (!length) {
            return;
          }

          var newIndex = ((hoveredSuggestIndex || 0) - 1 + length) % length;
          setHoveredSuggestIndex(newIndex);
          scrollToSuggest(newIndex);
          return;
        }

      case Keys.ARROW_DOWN:
        {
          var _length = suggests.length;

          if (!_length) {
            return;
          }

          var _newIndex = hoveredSuggestIndex !== null ? (hoveredSuggestIndex + 1) % _length : 0;

          setHoveredSuggestIndex(_newIndex);
          scrollToSuggest(_newIndex);
          return;
        }

      case Keys.ENTER:
        if (hoveredSuggestIndex === null) {
          onSubmit({
            value: value || '',
            event: event
          });
          return;
        }

        handleSelectSuggest(suggests[hoveredSuggestIndex]);
        return;
    }
  }, [handleBlur, suggests, hoveredSuggestIndex, value, onSubmit, setHoveredSuggestIndex]);
  var isOpened = !disabled && !readOnly && isBalloonOpened && (suggests.length > 0 || error);
  var renderSuggests = React.createElement(SuggestContent, null, error ? React.createElement(Note, {
    color: 'error'
  }, strings.error) : suggests.length ? React.createElement(MenuList, {
    ref: suggestListRef,
    suggestsMaxCount: suggestsMaxCount
  }, suggests.map(function (suggest, index) {
    var value = suggest.value,
        id = suggest.id;
    return React.createElement(ListItem, {
      key: value || id || index,
      selected: hoveredSuggestIndex === index,
      onClick: function onClick() {
        return handleSelectSuggest(suggest);
      }
    }, renderSuggestItem(suggest));
  })) : null);
  return React.createElement(StyledSuggest, {
    fullWidth: fullWidth
  }, React.createElement(SuggestBalloon, {
    content: renderSuggests,
    opened: isOpened,
    placement: 'bottom-start',
    showArrow: false,
    onOutsideClick: handleBlur,
    offsetY: 2,
    usePortal: false
  }, function (_ref7) {
    var ref = _ref7.ref;
    return React.createElement(TextField, Object.assign({}, props, {
      ref: ref,
      inputRef: inputRef,
      value: value,
      error: error,
      disabled: disabled,
      readOnly: readOnly,
      fullWidth: fullWidth
    }, loading ? {
      postfix: React.createElement(Loader, null)
    } : {}, {
      autoComplete: 'off',
      onKeyDown: handleKeydownInput,
      onChange: handleChangeTextField,
      onFocus: handleFocus,
      onBlur: handleTextFieldBlur
    }));
  }));
}